export const telegramAnalyticsBotName = 'rocket_data_bot';
